import { Box, Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, Tabs, Tab, Typography, Checkbox, FormControlLabel, TextField, IconButton, Select, MenuItem, Stack, Grid, Accordion, AccordionDetails, AccordionSummary, FormControl, InputLabel, Autocomplete } from '@mui/material';
import Divider from '@mui/material/Divider';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import React, { useState, useEffect } from 'react';
import AddIcon from "@mui/icons-material/Add";
import ApiCalls from "services/flick_erp_api_call";
import { hiringFlowLists } from './settingSlice';
import { useDispatch } from 'react-redux';
import { AddCircle, Expand, ExpandMore, RemoveCircle, Schema } from '@mui/icons-material';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import colors from 'assets/theme/base/colors';
import MDButton from 'components/MDButton';



function HiringFlows({permissions, modulePermissions}) {
    const loggedUser = JSON.parse(localStorage.getItem("user"));
    const loggedInOrgId = loggedUser?.org_id ? Number(loggedUser.org_id) : null;

    const [openHiringPopup, setOpenHiringPopup] = useState(false);
    const [currentHiringIndex, setCurrentHiringIndex] = useState(null);
    const [popupMode, setPopupMode] = useState("create");
		const [hiringFlowID, setHiringFlowID] = useState(null);

    // State to hold interviewers and their descriptions

    //response of stage data
    const [StageData, setStageData] = useState([]);
    const [stages, setStages] = useState([{ name: "", type : '', flow_stages: [{ name: "", description: "" }] }]);
    const [hiringFlowName, setHiringFlowName] = useState('');
    const [flowErrors, setFlowErrors] = useState({});

    const dispatch = useDispatch();
    const handleCreateFlow = () => {
        setCurrentHiringIndex(StageData.length);
        setStages([{ name: "", type: "", flow_stages: [{ name: "", description: "" }] }]); 
        setHiringFlowName('');
        setFlowErrors({});
        setPopupMode('create')
        //setSelectedStages([]); // Clear selected stages
        //setSelectedOptions([]); // Ensure selected options are cleared only when needed
        setOpenHiringPopup(true);
    };

    const handleClosePopup = () => {
        setOpenHiringPopup(false);
        setCurrentHiringIndex(null);
        setFlowErrors({});
        //setSelectedStages([]);
    };

    useEffect(() => {
        hiring();
        // hiringFlowSubStages();
    }, []);

    // Api for get hiring floe List
    async function hiring() {
        const res = await ApiCalls.getNewHiringFlow();
        if (res.success && res.code === 200) {
            setStageData(res.data);
            dispatch(hiringFlowLists({ hiring: res.data }));
        } else {
        }
    }

    const handleStagesClick = async (id, index, mode, selectedStage = null) => {
        try {
            const res = await ApiCalls.getStagesId(id); // Fetch hiring flow details
            if (res.success && res.code === 200) {
                setHiringFlowName(res.data.name); // Set hiring flow name
                setHiringFlowID(res.data.id);
                let filteredStages = res.data.flow_types.map(stage => (
                    {
                    id : stage.id,
                    name: stage.name,
                    flow_stages: stage.flow_stages,
                    sequence : stage.sequence,
                    type : stage.type
                }));
    
                if (selectedStage) {
                    // If a specific stage is clicked, filter the data to show only that stage
                    filteredStages = filteredStages.filter(stage => stage.name === selectedStage.name);
                }
    
                setStages(filteredStages);
                setCurrentHiringIndex(index);
                setPopupMode(mode);
                setOpenHiringPopup(true);
            }
        } catch (error) {
            console.error("Error fetching hiring stages:", error);
        }
    };
    
    const handleDeleteStage = async (id) => {
        const response = await ApiCalls.deleteHiringFlow(id);
        if (response?.success && response?.code === 204) {
            setStageData((prevStageData) => prevStageData.filter(flow => flow.id !== id));
        }
    };



    // Handle Changing Stage Name
    const handleStageChange = (index, value) => {
        const updatedStages = [...stages];
        updatedStages[index].name = value;
        setStages(updatedStages);
    };

    // Handle Adding New Stage
    const handleAddStage = () => {
        setStages([...stages, { name: "",type :'', flow_stages: [{ name: "", description: "" }] }]);
    };

    //const handleHiringStage = async (mode) => {
    //    const payload = {
    //        name: hiringFlowName,
    //        org_id: 3,
    //        created_by: loggedUser.employee_id,
    //        globle: true,
    //        flow_types: stages.map(({ name, type, flow_stages }, index) => (
    //            {
    //            name,
    //            type: type,    
    //            sequence:  index + 1 ,
    //            flow_stages: flow_stages?.map((subStage, subStageIndex) => ({
    //                name: subStage.name,
    //                description : subStage.description,
    //                sequence : subStageIndex + 1
    //            })),
    //        })),
    //    };

    //    if(mode === 'edit'){
    //        try {
    //            let response;
    //                response = await fetch(`${base_url}${flow_types}${stages[0]?.id}/`, {
    //                    method: "PATCH",
    //                    headers: {
    //                        "Content-Type": "application/json",
    //                        Authorization: `Bearer ${loggedUser?.access}`,
    //                    },
    //                    body: JSON.stringify(stages[0]),
    //                });
                
    
    //            if (!response.ok) {
    //                throw new Error(`API Error: ${response.statusText}`);
    //            }
    
    //            const data = await response.json();
    
    //            hiring(); // Refresh the list after creation or update
    //            handleClosePopup(); // Close the modal

    
    //        } catch (error) {
    //            console.error("Error in hiring flow operation:", error);
    //        }
    //    }else {
    //        try {
    //            let response;
    //                // Creating new hiring flow (POST API)
    //                response = await fetch(`${base_url}${new_hiring_flow}`, {
    //                    method: "POST",
    //                    headers: {
    //                        "Content-Type": "application/json",
    //                        Authorization: `Bearer ${loggedUser?.access}`,
    //                    },
    //                    body: JSON.stringify(payload),
    //                });
                
    
    //            if (!response.ok) {
    //                throw new Error(`API Error: ${response.statusText}`);
    //            }
    
    //            const data = await response.json();
    
    //            hiring(); // Refresh the list after creation or update
    //            handleClosePopup(); // Close the modal
    
    //        } catch (error) {
    //            console.error("Error in hiring flow operation:", error);
    //        }
    //    }
    //};

    //const validateHiringFlow = () => {
    //    const nextErrors = {};

    //    if (!hiringFlowName.trim()) {
    //        nextErrors.name = "Hiring flow name is required.";
    //    }

    //    stages.forEach((stage, stageIndex) => {
    //        if (!stage?.name?.trim()) {
    //            nextErrors[`stage-name-${stageIndex}`] = "Stage name is required.";
    //        }
    //        if (!stage?.type) {
    //            nextErrors[`stage-type-${stageIndex}`] = "Stage type is required.";
    //        }
    //        if (!stage?.flow_stages?.length) {
    //            nextErrors[`stage-flow-stages-${stageIndex}`] = "At least one substage is required.";
    //        }

    //        stage?.flow_stages?.forEach((subStage, subStageIndex) => {
    //            if (!subStage?.name?.trim()) {
    //                nextErrors[`substage-name-${stageIndex}-${subStageIndex}`] = "Substage name is required.";
    //            }
    //        });
    //    });

    //    setFlowErrors(nextErrors);
    //    return Object.keys(nextErrors).length === 0;
    //};

	const handleHiringStage = async (mode) => {
        //if (!validateHiringFlow() || !loggedInOrgId) {
        //    return;
        //}

		const payload = {
			name: hiringFlowName.trim(),
			org_id: loggedInOrgId,
			created_by: loggedUser.employee_id,
			globle: true,
			flow_types: stages.map((stage, index) => ({
				...(stage.id ? { id: stage.id } : {}),
				name: stage.name.trim(),
				type: stage.type,
				sequence: index + 1,
				flow_stages: stage.flow_stages.map((sub, subIndex) => ({
					...(sub.id ? { id: sub.id } : {}),
					name: sub.name.trim(),
					description: sub.description?.trim() || "",
					sequence: subIndex + 1
				}))
			}))
		};

        const response =
            mode === "edit"
                ? await ApiCalls.patchHiringFlow(hiringFlowID, payload)
                : await ApiCalls.createHiringFlow(payload);

        if (response?.success && [200, 201].includes(response.code)) {
            await hiring();
            handleClosePopup();
        }
	};

    const handleSubStageChange = (stageIndex, subStageIndex, label, value) => {
        const updatedStages = [...stages];
    
        // Update the specific field dynamically
        updatedStages[stageIndex].flow_stages[subStageIndex] = {
            ...updatedStages[stageIndex].flow_stages[subStageIndex],
            [label]: value, 
        };
    
        setStages(updatedStages);
    };

    const handleAddSubStage = (stageIndex) => {
        const updatedStages = [...stages];
        updatedStages[stageIndex].flow_stages.push({ name: "", description: "" });
        setStages(updatedStages);
    };

    const handleRemoveStage = (index) => {
        const updatedStages = [...stages];
        updatedStages.splice(index, 1);
        setStages(updatedStages);
    };

    const handleRemoveSubStage = (stageIndex, subStageIndex) => {
        const updatedStages = [...stages];
        updatedStages[stageIndex].flow_stages.splice(subStageIndex, 1);
        setStages(updatedStages);
    };

    const handleStageTypeChange = (index, type) => {
        const updatedStages = [...stages];
        updatedStages[index].type = type.value;
        setStages(updatedStages);
    };

    const STAGE_TYPE_OPTIONS = [
        { value: 1, label: "New" },
        { value: 2, label: "Screening" },
        { value: 3, label: "System Test" },
        { value: 4, label: "Interview" },
        { value: 5, label: "Selected" },
        { value: 6, label: "Job Offered" },
        { value: 7, label: "Onboarded" },
        { value: 8, label: "Archived" },
    ];

    const renderHiringModalPopup = () => {
        return (
            <Dialog
                open={openHiringPopup}
                onClose={handleClosePopup}
                fullWidth
                maxWidth="md"
                sx={{ "& .MuiDialog-paper": { width: "700px", maxWidth: "80vw" } }}
            >
                <DialogTitle>
                    {popupMode === "view" ? "View Hiring Flow" :
                        (currentHiringIndex !== null && currentHiringIndex < StageData.length
                            ? "Edit Hiring Flow"
                            : "Create New Hiring Flow")}
                </DialogTitle>
                <DialogContent>
                    <Box>
                        <Typography variant="h6" gutterBottom>
                            Hiring Flow Name
                        </Typography>
                        <TextField
                            fullWidth
                            placeholder="Enter hiring flow name"
                            value={hiringFlowName}
                            onChange={(e) => setHiringFlowName(e.target.value)}
                            sx={{ mb: 3 }}
                            disabled={popupMode === "view"}
                            error={Boolean(flowErrors.name)}
                            helperText={flowErrors.name}
                        />
                        <Box display='flex' justifyContent='space-between'>
                            <Typography variant="h6" gutterBottom>
                                Enter Hiring Stages
                            </Typography>
                            {popupMode !== "view" && (
                                <Button size='small' startIcon={<AddCircle />} variant='text' onClick={handleAddStage}>
                                    Add Stage
                                </Button>
                            )}
                        </Box>


                        {stages?.map((stage, stageIndex) => (
                            <Card key={stageIndex} sx={{ p: 2, mb: 2, boxShadow: 3 }}>
                                <Box sx={{ display: "flex", justifyContent: 'space-between', gap: 2 }}>
                                    <Box display="flex" flexDirection="column" gap={1}>
                                        <Typography variant="h6" fontSize="13px" alignSelf="flex-start">
                                            {`Stage ${stageIndex + 1}`}
                                        </Typography>

                                        <Box display="flex" gap={2}>
                                            <TextField
                                                label="Stage Name"
                                                value={stage.name}
                                                onChange={(e) => handleStageChange(stageIndex, e.target.value)}
                                                disabled={popupMode === "view"}
                                                fullWidth
                                                error={Boolean(flowErrors[`stage-name-${stageIndex}`])}
                                                helperText={flowErrors[`stage-name-${stageIndex}`]}
                                            />

                                            <Autocomplete
                                                options={STAGE_TYPE_OPTIONS}
                                                getOptionLabel={(option) => option.label}
                                                value={STAGE_TYPE_OPTIONS.find((opt) => opt.value === stage.type) || null}
                                                onChange={(e, newValue) => {
                                                    handleStageTypeChange(stageIndex, newValue ? newValue : "");
                                                }}
                                                disabled={popupMode === "view"}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Stage Type"
                                                        error={Boolean(flowErrors[`stage-type-${stageIndex}`])}
                                                        helperText={flowErrors[`stage-type-${stageIndex}`]}
                                                    />
                                                )}
                                                fullWidth
                                            />
                                        </Box>
                                    </Box>


                                    {popupMode !== "view" && (
                                        <Box display='flex' alignContent='right'>
                                            <IconButton sx={{ marginTop: '20px' }} size='medium' onClick={() => handleAddSubStage(stageIndex)} >
                                                <AddCircle />
                                            </IconButton>
                                            {stages.length > 1 && (
                                                <IconButton sx={{ marginTop: '20px' }} size='medium' onClick={() => handleRemoveStage(stageIndex)} >
                                                    <RemoveCircle />
                                                </IconButton>
                                            )}
                                        </Box>
                                    )}
                                </Box>

                                {/* Substages arranged in a 2-column grid */}
                                <Grid container spacing={2} sx={{ mt: 2 }}>
                                    {stage?.flow_stages.map((subStage, subStageIndex) => (
                                        <Grid item xs={12} sm={6} key={subStageIndex}>
                                            <Box sx={{ display: "flex", alignItems: "center", gap: 1, }}>
                                                <Box sx={{ width: "100%" }}>
                                                    <Typography variant="body" fontSize='13px'>{`Substage ${subStageIndex + 1}`}</Typography>
                                                    <TextField
                                                        fullWidth
                                                        value={subStage.name}
                                                        onChange={(e) => handleSubStageChange(stageIndex, subStageIndex, 'name', e.target.value)}
                                                        disabled={popupMode === "view"}
                                                        error={Boolean(flowErrors[`substage-name-${stageIndex}-${subStageIndex}`])}
                                                        helperText={flowErrors[`substage-name-${stageIndex}-${subStageIndex}`]}
                                                    />
                                                    <Typography variant="body" fontSize='13px'>{` Description`}</Typography>
                                                    <TextField
                                                        fullWidth
                                                        value={subStage.description}
                                                        onChange={(e) => handleSubStageChange(stageIndex, subStageIndex, 'description', e.target.value)}
                                                        disabled={popupMode === "view"}
                                                    />
                                                </Box>
                                                {popupMode !== "view" && (
                                                    <IconButton size='small' sx={{ marginTop: '20px' }} onClick={() => handleRemoveSubStage(stageIndex, subStageIndex)} >
                                                        <RemoveCircle />
                                                    </IconButton>
                                                )}
                                            </Box>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Card>
                        ))}
                    </Box>
                </DialogContent>
                <DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Button onClick={handleClosePopup} color="primary">
                        Close
                    </Button>
                    {popupMode !== "view" && (
                        <Button sx={{ mt: 1, color: "#fff" }} size='small' variant="contained" onClick={() => handleHiringStage(popupMode)}>
                            Confirm
                        </Button>
                    )}
                </DialogActions>
            </Dialog>
        )
    }

    return (
			<DashboardLayout>
				<DashboardNavbar />

				<Card sx={{ mt: 2, p: 2 }}>

					<MDBox style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginTop: 6, marginBottom: 36 }}>
						<MDBox sx={{ display: "flex", alignItem: "center", gap: 3 }}>
							<MDBox
								sx={{
									width: 48,
									height: 48,
									borderRadius: "16px",
									display: "grid",
									placeItems: "center",
									background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.info.main} 100%)`,
									color: colors.white.main,
								}}
							>
								<Schema />
							</MDBox>
							<MDBox>
								<MDTypography variant="h4">Hiring Flow</MDTypography>
								<MDTypography variant="body2" color="text">
									Create or manage the hiring flow for different profiles
								</MDTypography>
							</MDBox>
						</MDBox>
							<MDBox>
								{permissions?.includes(modulePermissions?.create_permission) && (
									<MDButton variant="gradient" color='info' onClick={handleCreateFlow} sx={{ display: "flex", justifyContent: "right" }}>Create Flow</MDButton>
								)}
							</MDBox>
					</MDBox>
					{permissions?.includes(modulePermissions?.list_permission) && (
						StageData.map((item, index) => (
							<Accordion
								key={index}
								sx={{
									mb: 2,
									border: "1px solid #ddd",
									borderRadius: 2,
									boxShadow: "2px 2px 5px rgba(0,0,0,0.1)",
									"&:before": { display: "none" }, // Removes default accordion divider line
									"&.Mui-expanded": { backgroundColor: "#f0f7ff" } // Highlight when expanded
								}}
							>
								<AccordionSummary
									expandIcon={<ExpandMore />}
									sx={{
										display: "flex",
										alignItems: "center",
										minHeight: "60px",
										"& .MuiAccordionSummary-content": { display: "flex", alignItems: "center" }
									}}
								>
									{/* Accordion Title */}
									<Typography variant="h6" sx={{ fontWeight: 600 }}>
										{item.name}
									</Typography>

									{/* Edit & Delete Icons */}
									{permissions?.includes(modulePermissions?.delete_permission) && (
										<Box sx={{ display: "flex", marginLeft: "auto", alignItems: "center" }}>
											<EditIcon
												sx={{ cursor: "pointer", mr: 2, transition: "0.3s", "&:hover": { color: "blue" } }}
												onClick={(e) => {
													e.stopPropagation();
													handleStagesClick(item.id, index, 'edit')
												}}
											/>
											<DeleteIcon
												sx={{ cursor: "pointer", transition: "0.3s", "&:hover": { color: "red" } }}
												onClick={() => handleDeleteStage(item.id)}
											/>
										</Box>
									)}
								</AccordionSummary>

								<AccordionDetails>
									{item?.flow_types?.map((flow, index) => (
										<Card key={flow.id} sx={{ mb: 1, p: 1.5, backgroundColor: "#f9f9f9", borderRadius: 2 }}>
											<Typography variant="h6" color="primary">{flow.name}</Typography>
											<Divider sx={{ my: 1 }} />
											<Box
												sx={{
													display: "grid",
													gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))",
													gap: 1.5
												}}
											>
												{flow.flow_stages.length > 0 ? (
													flow.flow_stages.map((stage) => (
														<Box
															key={stage.id}
															sx={{
																p: 1,
																border: "1px solid #ddd",
																borderRadius: 2,
																backgroundColor: "#ffffff",
																textAlign: "center",
																boxShadow: "1px 1px 5px rgba(0,0,0,0.1)",
																fontSize: "14px"
															}}
															onClick={() => handleStagesClick(item.id, index, 'edit', flow)}
														>
															<Typography variant="subtitle2" fontWeight="bold">
																{stage.name}
															</Typography>
															<Typography variant="caption" color="text.secondary" sx={{ whiteSpace: "pre-wrap" }}>
																{stage.description || "No description"}
															</Typography>
														</Box>
													))
												) : (
													<Typography variant="body2" color="text.secondary">No stages available.</Typography>
												)}
											</Box>
										</Card>
									))}
								</AccordionDetails>
							</Accordion>
						))
					)}
				</Card>

				{/* Popup Dialog for Creating/Editing Hiring */}

				{openHiringPopup && renderHiringModalPopup()}

			</DashboardLayout>
    );
}

export default HiringFlows;

//import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Button, Card, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField } from "@mui/material";
//import MDBox from "components/MDBox";
//import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
//import DashboardNavbar from "examples/Navbars/DashboardNavbar";
//import colors from "assets/theme/base/colors";
//import { AddCircle, Delete, Edit, ExpandMore, RemoveCircle, Schema } from "@mui/icons-material";
//import MDButton from "components/MDButton";
//import MDTypography from "components/MDTypography";
//import ApiCalls from "services/flick_erp_api_call";
//import { useEffect, useState } from "react";
//import { new_hiring_flow } from "services/apis";
//import { base_url } from "services";
//import { IconButton } from "@material-ui/core";


//export default function HiringFlows({permissions, modulePermissions}){
	
//	const [hiringFlowList, setHiringFlowList] = useState([]);
//	const [flowData, setFlowData] = useState({})
//	const [openCreateFlowModal, setOpenCreateFlowModal] = useState(false);
//	const [popupMode, setPopupMode] = useState();
//	const [stages, setStages] = useState([
//		{
//			name : "", 
//			type : "", 
//			flow_stages : [""]
//		}
//	]);

//	const STAGE_TYPE_OPTIONS = [
//		{ value: 1, label: "New" },
//		{ value: 2, label: "Screening" },
//		{ value: 3, label: "System Test" },
//		{ value: 4, label: "Interview" },
//		{ value: 5, label: "Selected" },
//		{ value: 6, label: "Job Offered" },
//		{ value: 7, label: "Onboarded" },
//		{ value: 8, label: "Archived" },
//	];


//	useEffect(() => {
//      async function fetchHiringFlows(){
//				const response = await ApiCalls.getNewHiringFlow();
//				console.log(response)
//				if(response.data && response.code === 200) {
//          setHiringFlowList(response.data)
//				}
//			}

//			fetchHiringFlows();
//	},[])


//	const handleCreateFlow = () => {
//		setPopupMode('create');
//		setOpenCreateFlowModal(!openCreateFlowModal)
//	}

//	const handleEditFlowClick = async(id, index, mode, selectedStage = null) => {
//		console.log("id, index, mode", id, index, mode)
//		const res = await ApiCalls.getStagesId(id);
//		if(res.data && res.code === 200){
//			 setFlowData(res.data);
//			 let filteredStages = res.data.flow_types.map(stage => (
//				{
//					id : stage.id,
//					name : stage.name,
//					flow_stages : stage.flow_stages,
//					sequence : stage.sequence,
//					type : stage.type
//				}
//			 ))

//			if (selectedStage) {
//				// If a specific stage is clicked, filter the data to show only that stage
//				filteredStages = filteredStages.filter(stage => stage.name === selectedStage.name);
//			}
//      setStages(filteredStages);
//      setPopupMode('edit');
//			setOpenCreateFlowModal(true);
//		}
//	}

//	const handleDeleteFlow = async (id) => {
//		try {
//			const response = await fetch(`${base_url}${new_hiring_flow}${id}/`, {
//				method: "DELETE",
//				headers: {
//					"Content-Type": "application/json",
//					Authorization: `Bearer ${loggedUser?.access}`,
//				},
//			});

//			if (!response.ok) {
//				throw new Error(`API Error: ${response.statusText}`);
//			}
//		} catch (error) {
//			console.error("Error deleting hiring flow:", error);
//		}
//	};

//	const handleAddNewStage = () => {
//    setStages([...stages, {name : "", type : "", flow_stages : []}])
//		console.log("handleAddStages", stages)
//	}

//	const handleAddSubStages = (index) => {
//    const updatedStages = [...stages];
//		updatedStages[index].flow_stages.push({name : "", description : ""});
//		setStages(updatedStages)
//	}

//	const handleRemoveSubStages = (stageIndex, subStageIndex) => {
//		const updatedStages = [...stages];
//		updatedStages[stageIndex].flow_stages.splice(subStageIndex, 1);
//		setStages(updatedStages);
//	}

//	const handleSubStageChange = (stageIndex, subStageIndex, label, value) => {
//		const updatedStages = [...stages];

//		// Update the specific field dynamically
//		updatedStages[stageIndex].flow_stages[subStageIndex] = {
//			...updatedStages[stageIndex].flow_stages[subStageIndex],
//			[label]: value,
//		};

//		setStages(updatedStages);
//	};

//	const handleConfirmClick = () =>{
 
//	}

//	const renderCreateUpdateModal = () => {
//		return (
//			<Dialog
//				open={openCreateFlowModal}
//				onClose={() => setOpenCreateFlowModal(!openCreateFlowModal)}
//				fullWidth
//				sx={{ "& .MuiDialog-paper": { width: "700px", maxWidth: "80vw" } }}
//			>
//				<DialogTitle>{popupMode === 'create' ? "Create New Hiring Flow" : "Edit Hiring Flow"}</DialogTitle>
//				<DialogContent>
//					<MDBox>
//						<MDTypography variant='h6'>Hiring Flow Name</MDTypography>
//						<TextField
//							fullWidth
//							placeholder="Enter Hiring Flow Name"
//							value={''}
//							sx={{ mb: 3 }}
//						/>
//						<MDBox display='flex' justifyContent='space-between'>
//							<MDTypography variant='h6' gutterbottom>Enter Hiring Stages</MDTypography>
//							<Button
//								size='small'
//								startIcon={<AddCircle />}
//								variant='text'
//								onClick={handleAddNewStage}
//							>
//								Add Stage
//							</Button>
//						</MDBox>
//						{
//							stages?.map((stage, index) => (
//								<Card key={index} sx={{ p: 2, mb: 2, boxShadow: 3 }}>
//									<MDBox sx={{ display: 'flex', justifyContent: "space-between", gap: 2 }}>
//										<MDBox sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
//											<MDTypography variant='h6'>{`Stage ${index + 1}`}</MDTypography>
//											<MDBox display='flex' gap={2}>
//												<TextField
//													label="Stage Name"
//													value={stage.name}
//													onChange={(e) => {
//														const updatedStages = [...stages];
//														updatedStages[index].name = e.target.value;
//														setStages(updatedStages);
//													}}
//												/>

//												<Autocomplete
//													fullWidth
//													options={STAGE_TYPE_OPTIONS}
//													getOptionLabel={(option) => option.label}
//													value={STAGE_TYPE_OPTIONS.find((opt) => opt.value === stage.type) || null}
//													onChange={(e, newValue) => {
//														const updatedStages = [...stages];
//														updatedStages[index].type = newValue
//														setStages(updatedStages);
//													}}
//													renderInput={(params) => {
//														<TextField {...params} label='Stage Type' />
//													}}
//												/>
//											</MDBox>
//										</MDBox>
//										<MDBox display='flex' alignContent='right'>
//											<IconButton sx={{ marginTop: '20px' }} size='medium' onClick={() => handleAddSubStages(index)} >
//												<AddCircle />
//											</IconButton>
//											{stages.length > 1 && (
//												<IconButton sx={{ marginTop: '20px' }} size='medium'
//													onClick={() => {
//														const updatedStages = [...stages];
//														updatedStages.splice(index, 1);
//														setStages(updatedStages);
//													}}>
//													<RemoveCircle />
//												</IconButton>
//											)}
//										</MDBox>
//									</MDBox>

//									<Grid container spacing={2} sx={{ mt: 2 }}>
//										{
//											stage?.flow_stages.map((subStage, subStageIndex) => (
//												<Grid item xs={12} sm={6} key={subStageIndex}>
//													<MDBox sx={{ display: "flex", alignItems: "center", gap: 1, }}>
//														<MDBox sx={{ width: "100%" }}>
//															<MDTypography variant="body" fontSize='13px'>{`Substage ${subStageIndex + 1}`}</MDTypography>
//															<TextField
//																fullWidth
//																value={subStage.name}
//																onChange={(e) => handleSubStageChange(index, subStageIndex, 'name', e.target.value)}
//															/>
//															<MDTypography>Description</MDTypography>
//															<TextField
//																fullWidth
//																value={subStage.description}
//																onChange={(e) => handleSubStageChange(index, subStageIndex, 'description', e.target.value)}
//															/>
//														</MDBox>
//														<IconButton size='small' sx={{ marginTop: '20px' }} onClick={() => handleRemoveSubStages(stageIndex, subStageIndex)}></IconButton>
//													</MDBox>
//												</Grid>
//											))
//										}
//									</Grid>
//								</Card>
//							))
//						}
//					</MDBox>
//				</DialogContent>
//				<DialogActions sx={{ display: 'flex', justifyContent: 'space-between' }}>
//					<MDButton
//						onClick={() => {
//							setOpenHiringPopup(false);
//						}}
//						color="primary"
//					>
//						Close
//					</MDButton>
//					<MDButton sx={{ mt: 1, color: "#fff" }} size='small' variant="contained" onClick={() => handleConfirmClick()}>
//						Confirm
//					</MDButton>
//				</DialogActions>
//			</Dialog>
//		)
//	}

	
//	return(
//		<DashboardLayout>
//			<DashboardNavbar />
//			<Card sx = {{mt : 2, p : 2}}>
//				<MDBox style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, marginTop: 6, marginBottom: 36 }}>
//					<MDBox sx={{ display: "flex", alignItem: "center", gap: 3 }}>
//						<MDBox
//							sx={{
//								width: 48,
//								height: 48,
//								borderRadius: "16px",
//								display: "grid",
//								placeItems: "center",
//								background: `linear-gradient(135deg, ${colors.primary.main} 0%, ${colors.info.main} 100%)`,
//								color: colors.white.main,
//							}}
//						>
//							<Schema />
//						</MDBox>
//						<MDBox>
//							<MDTypography variant="h4">Hiring Flow</MDTypography>
//							<MDTypography variant="body2" color="text">
//								Create or manage the hiring flow for different profiles
//							</MDTypography>
//						</MDBox>
//					</MDBox>
//					<MDBox>
//						{permissions?.includes(modulePermissions?.create_permission) && (
//							<MDButton variant="gradient" color='info' onClick={handleCreateFlow} sx={{ display: "flex", justifyContent: "right" }}>Create Flow</MDButton>
//						)}
//					</MDBox>
//				</MDBox>
//				{
//					permissions.includes(modulePermissions.list_permission) && (
//						hiringFlowList.map((flow, index) => (
//							<Accordion
//							  key={index}
//								sx={{
//									mb: 2,
//									border: "1px solid #ddd",
//									borderRadius: 2,
//									boxShadow: "2px 2px 5px rgba(0,0,0,0.1)",
//									"&:before": { display: "none" }, // Removes default accordion divider line
//									"&.Mui-expanded": { backgroundColor: "#f0f7ff" } // Highlight when expanded
//								}}
//							>
//								<AccordionSummary
//								  expandIcon = {<ExpandMore/>}
//									sx={{
//										display: "flex",
//										alignItems: "center",
//										minHeight: "60px",
//										"& .MuiAccordionSummary-content": { display: "flex", alignItems: "center" }
//									}}
//								>
//									<MDTypography>{flow.name}</MDTypography>
//									{
//										permissions?.includes(modulePermissions.delete_permission) && (
//											<MDBox sx={{ display: "flex", marginLeft: "auto", alignItems: "center" }}>
//												<Edit
//												  sx={{ cursor: "pointer", mr: 2, transition: "0.3s", "&:hover": { color: "blue" } }}
//													onClick={(e) => {
//														e.stopPropagation();
//														handleEditFlowClick(flow.id, index, 'edit')
//													}}
//												/>
//												<Delete
//												  sx={{ cursor: "pointer", mr: 2, transition: "0.3s", "&:hover": { color: "blue" } }}
//													onClick={() => handleDeleteFlow(flow.id)}
//												/>
//											</MDBox>
//										)
//									}
//								</AccordionSummary>
//								<AccordionDetails></AccordionDetails>
//							</Accordion>
//						))
//					)
//				}
//				{openCreateFlowModal && renderCreateUpdateModal()}
//			</Card>
//		</DashboardLayout>
//	)
//}
